import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import { useStores } from '../../../stores';
import { useNavigate } from 'react-router-dom';
import {
  RISK_PROFILING_BY_CHRONIC,
  RISK_PROFILING_BY_COST,
  RISK_PROFILING_BY_TRIGGER,
  RISK_PROFILING_BY_UTILIZATION,
} from '../../../core-utils/routes';
import {
  RiskStratificationChart,
  // NoDataVisual,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import NoTabsData from '../../molecules/NoTabsData';
import NoContent from '../../atoms/Icons/NoContent';
import properties from '../../../core-utils/properties';
import axios from 'axios';
import Loader from '../../molecules/Loader';
import {
  formatRiskCost,
  formatRiskStratificationBreakDown,
  // formatRiskStratificationCumulative,
  formatRiskUtilization,
  formatTriggerConditions,
  RiskStratificationCumulative,
} from '../../../core-utils/helper-utils/summaryReportHelper';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import summaryPageConstants from '../../../core-utils/messages/summaryPageConstants';
import { useAPIPayload } from '../../../core-utils/helper-utils/apiPayloadHelper';

//
// ─── INTERFACES / PROPS
//
export interface RiskProfilingProps {
  // riskStratificationData: any[];
  incurredStartDate: any;
  incurredEndDate: any;
  paidStartDate: any;
  paidEndDate: any;
  isPlanDatesFetched: any;
  aggregationParameter: any;
}

//
// ─── useStyles
//
const useStyles = makeStyles()({
  outerCont: {
    height: '500px',
    // border: '1px solid #E5E9F0',
    // borderRadius: '4px',
  },
  mainContainer: {
    marginTop: '70px',
    padding: '5px',
  },
  noDataContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '540px',
    border: '1px solid #E5E9F0',
    borderRadius: '4px',
  },
  headerContainer: {
    marginBottom: '20px',
  },
});

// ─── COMPONENT
const RiskStratificationTab: React.FC<RiskProfilingProps> = observer(
  ({
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
  }) => {
    const { classes } = useStyles();
    const navigate = useNavigate();
    const summaryCardsStore = useStores().summaryCardsStore;
    const employerGroupStore = useStores().employerGroupStore;
    const cohortDetailsStore = useStores().cohortDetailsStore;
    const payload = useAPIPayload();
    const messages = summaryPageConstants.SUMMARY_PAGE.SUMMARY_CARDS;

    // useState
    const abortController = new AbortController();
    const [loading, setLoading] = useState(true);
    const [mainLoader] = useState<any>(<Loader height="400px" />);
    const [riskCost, setRiskCost] = useState<RiskStratificationCumulative[]>(
      [],
    );
    const [riskUtilization, setRiskUtilization] = useState<
      RiskStratificationCumulative[]
    >([]);
    const [riskTriggerConditions, setRiskTriggerConditions] = useState<
      RiskStratificationCumulative[]
    >([]);
    const [
      riskStratificationCumulative,
      setRiskStratificationCumulative,
    ] = useState<RiskStratificationCumulative[]>([]);
    const getTypeOfScreen = (type: string | undefined) => {
      switch (type) {
        case 'Chronic':
          return 'chronic';
        case 'Trigger Conditions':
          return 'trigger';
        case 'Cost':
          return 'cost';
        case 'Utilization':
          return 'utilization';
        default:
          return 'chronic';
      }
    };
    const getUrlByType = (type: string | undefined) => {
      switch (type) {
        case 'Chronic':
          return RISK_PROFILING_BY_CHRONIC;
        case 'Trigger Conditions':
          return RISK_PROFILING_BY_TRIGGER;
        case 'Cost':
          return RISK_PROFILING_BY_COST;
        case 'Utilization':
          return RISK_PROFILING_BY_UTILIZATION;
        default:
          return RISK_PROFILING_BY_CHRONIC;
      }
    };
    const storeMemberIds = (
      memberIds: string[],
      tier: string,
      type?: string,
    ) => {
      summaryCardsStore.addMemberIds(memberIds);
      // history.push(RISK_PATIENT_DETAILS, {
      //   memberIds,
      //   tier: tier,
      //   type: type,
      // });
      navigate(getUrlByType(type), {
        state: {
          isRiskStrat: true,
          memberIds,
          tier: tier,
          type: getTypeOfScreen(type),
          count: memberIds.length,
        },
      });
    };

    // ─── Functions / API Calls

    // const getRiskStratification = async () => {
    //   const endpoint = properties.riskPrevalence;
    //   try {
    //     setLoading(true);
    //     const response = await axios.post(
    //       properties.aiqBaseUrl + properties.summaryBaseUrl + endpoint,
    //       {
    //         startDate:
    //           aggregationParameter === 'paid'
    //             ? paidStartDate
    //             : incurredStartDate,
    //         endDate:
    //           aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
    //         eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
    //         claim_id_list: [],
    //         member_unique_id_list: [],
    //         max_claim_date:
    //           employerGroupStore?.employerGroupResponseData?.max_claim_date,
    //       },
    //       { signal: abortController.signal },
    //     );

    //     let data: any[] = [];
    //     data = response?.data?.data?.riskPrevalence || [];
    //     // setRiskStratificationData(
    //     //   formatRiskStratificationData(data, 'chronic'),
    //     // );
    //     setRiskStratificationCumulative(
    //       formatRiskStratificationCumulative(data),
    //     );
    //     setLoading(false);
    //   } catch (error) {
    //     setLoading(false);
    //     console.error('error in risk stratification', error);
    //   }
    // };

    const formatRiskStratificationCumulative = (data: any) => {
      const riskStratificationCumulative: RiskStratificationCumulative[] = [];
      data?.map((item: any) => {
        const eachValue: RiskStratificationCumulative = {
          tier: '',
          count: 0,
          memberIds: [],
          handleClick: () => {},
        };
        eachValue.tier = item._id;
        eachValue.count = item.member_unique_id_list.length;
        eachValue.memberIds = item.member_unique_id_list;
        eachValue.handleClick = () => {
          navigate(getUrlByType('Chronic'), {
            state: {
              isRiskStrat: true,
              memberIds: item.member_unique_id_list,
              tier: item._id,
              type: 'chronic',
              count: item.member_unique_id_list.length,
            },
          });
        };
        riskStratificationCumulative.push(eachValue);
      });

      const tiers = ['Tier 1', 'Tier 2', 'Tier 3', 'Tier 4', 'Tier 5'];
      const formattedData = tiers.map((tierName) => {
        const tierData = riskStratificationCumulative.find(
          (tier) => tier.tier === tierName,
        );
        return (
          tierData || {
            tier: tierName,
            count: 0,
            memberIds: [],
            handleClick: () => {},
          }
        );
      });
      return formattedData;
    };

    const getRiskStratification = async () => {
      try {
        setLoading(true);
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.summaryBaseUrl +
            properties.riskStratification,
          {
            ...payload,
            max_claim_date:
              employerGroupStore?.employerGroupResponseData?.max_claim_date,
            claim_id_list: cohortDetailsStore.claimIdList,
            member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
          },
          { signal: abortController.signal },
        );

        const data = response?.data?.data;

        if (data) {
          setRiskStratificationCumulative(
            formatRiskStratificationCumulative(data?.riskPrevalence),
          );

          setRiskCost(formatRiskCost(data?.riskCost, storeMemberIds));

          setRiskUtilization(
            formatRiskUtilization(data?.riskUtilization, storeMemberIds),
          );

          setRiskTriggerConditions(
            formatTriggerConditions(data?.riskTrigger, storeMemberIds),
          );
        }
      } catch (error) {
        console.error('Error fetching risk stratification:', error);
      } finally {
        setLoading(false);
      }
    };

    const getRiskStratificationData = () => {
      return formatRiskStratificationBreakDown(
        riskCost,
        riskUtilization,
        riskTriggerConditions,
        // riskConsumption,
      );
    };

    useEffect(() => {
      getRiskStratification();
    }, [
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      aggregationParameter,
    ]);

    return loading ? (
      mainLoader
    ) : (
      <Grid className={classes.outerCont}>
        {getRiskStratificationData()?.riskStratificationData?.some(
          (entry: any) => entry.uniqueMemberIds?.length > 0,
        ) ? (
          <RiskStratificationChart
            cardHeight="100%"
            cardWidth="100%"
            iceBurgWidth="330px"
            iceBurgHeight="400px"
            labelGridStyles={{
              marginLeft: '59px',
              marginTop: '50px',
            }}
            valuesLeftMargin="140px"
            valuesTopMargins={{
              first: '54px',
              second: '136px',
              third: '204px',
              fourth: '283px',
              fifth: '340px',
            }}
            tableTopMargin="40px"
            chartHeight="350"
            chartWidth="850"
            riskStratificationChartColumns={
              getRiskStratificationData().riskStratificationColumns
            }
            riskStratificationChartRows={
              getRiskStratificationData().riskStratificationRows
            }
            riskStratificationChartData={
              getRiskStratificationData().riskStratificationData
            }
            riskSummaryData={riskStratificationCumulative}
            toolTipStyles={{ textAlign: 'justify' }}
            riskStatificationCumulativeLabels={
              messages.RISK_STRATIFICATION_CUMULATIVE_LABELS
            }
            riskStratificationLabels={messages.RISK_STRATIFICATION_LABELS_EXP}
            toggleStyles={{
              toggleLeftStyles: {
                border: 'none',
                borderRight:
                  '1px solid ' + patientAccessTheme.palette.grey[300],
                width: '150px',
              },
              toggleRightStyles: {
                border: 'none',
                borderLeft: '1px solid ' + patientAccessTheme.palette.grey[300],
                width: '150px',
              },
            }}
          />
        ) : (
          <Grid className={classes.noDataContainer}>
            <NoTabsData
              icon={<NoContent />}
              label="No risk stratification data available !"
            />
          </Grid>
        )}
      </Grid>
    );
  },
);

export default RiskStratificationTab;
